import { Route } from 'react-router';
import { VendorVaultPage } from '../VendorVaultPage';
import { getVendorVaultPath } from '../path/path';

export const VendorVaultRoutes = [
  <Route key={getVendorVaultPath()} path={getVendorVaultPath()} element={<VendorVaultPage />} />,
];
